module.exports = __webpack_public_path__ + "img/computer.5716a7cb.svg";